"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _typeof2 = _interopRequireDefault(require("@babel/runtime/helpers/typeof"));

var _immutable = require("immutable");

var _PropertyFieldTypes = require("./PropertyFieldTypes");

var _PropertyOptionRecord = _interopRequireDefault(require("./PropertyOptionRecord"));

var _PropertyTypes = require("./PropertyTypes");

var PropertyRecord = (0, _immutable.Record)({
  calculated: false,
  createdAt: null,
  createdUserId: null,
  defaultValue: undefined,
  deleted: false,
  description: '',
  displayMode: 'current_value',
  displayOrder: 0,
  expression: null,
  externalOptions: false,
  favorited: false,
  favoritedOrder: 0,
  fieldType: _PropertyFieldTypes.TEXT,
  filterName: '',
  formField: true,
  groupName: null,
  hidden: false,
  hubspotDefined: false,
  isBidenProperty: false,
  isCustomizedDefault: false,
  label: '',
  mutableDefinitionNotDeletable: true,
  name: '',
  numberDisplayHint: 'formatted',
  objectType: undefined,
  options: (0, _immutable.List)(),
  optionsAreMutable: false,
  optionSortStrategy: null,
  placeholder: '',
  prospectType: null,
  readOnlyDefinition: false,
  readOnlyValue: false,
  referencedObjectType: null,
  searchable: true,
  searchableInGlobalSearch: false,
  showCurrencySymbol: false,
  sortable: true,
  textDisplayHint: '',
  type: _PropertyTypes.STRING,
  updatedUserId: null
}, 'PropertyRecord');

PropertyRecord.fromJS = function (json) {
  if (!json || (0, _typeof2.default)(json) !== 'object') {
    return json;
  }

  var property = PropertyRecord(json);
  var options = (0, _immutable.Seq)(property.options || (0, _immutable.List)()).map(_PropertyOptionRecord.default.fromJS).toList();
  var normalizedProperty = property.set('options', options);
  return normalizedProperty;
};

PropertyRecord.savableFields = ['description', 'externalOptions', 'fieldType', 'formField', 'groupName', 'label', 'name', 'options', 'optionSortStrategy', 'referencedObjectType', 'showCurrencySymbol', 'type', 'numberDisplayHint', 'searchableInGlobalSearch'];
var _default = PropertyRecord;
exports.default = _default;
module.exports = exports.default;